module.exports = __webpack_public_path__ + "media/images/client-5-47fd15e57c87c239355f6ef4309bad89.png";